export default "__VITE_ASSET__oCIm_o92__"